import { createSelector } from 'reselect';

const selectCancelReasons = (state: any) => state.cancelReasons;


export const selectCancelReasonsCurrentItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.current);

export const selectCancelReasonsListItems = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.list);

export const selectCancelReasonsItemById = (itemId: any) =>
    createSelector(selectCancelReasonsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCancelReasonsQueryItems = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.query);

export const selectCancelReasonsCreatedItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.create);

export const selectCancelReasonsUpdatedItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.update);

export const selectCancelReasonsReadItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.read);

export const selectCancelReasonsDeletedItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.delete);

export const selectCancelReasonsearchedItems = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.search);

export const selectCancelReasonsItemsCount = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.count);

export const selectCancelReasonsItemsFilter = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.filter);